/** The company's own texts (docs/features/homeowner-language.md, "The company's own texts"): a text homeowners read
 * is null for ours, translated into each homeowner's language, or the company's own words, shown as written in every
 * language. The switch "Write my own text" moves between the two. Pure, tested with node --test. */

/** Whether the company writes this text itself (a list, the proposal's steps: when it has any). */
export function isOwnText(value: string | null | undefined | readonly unknown[]): boolean {
  return Array.isArray(value) ? value.length > 0 : value != null;
}

/** The value when the switch goes on: our text in the company's main language, to edit from (never empty while
 * ours is known). */
export function startOwnText(ours: string | null | undefined): string {
  return ours ?? "";
}

/** What is wrong with an own text: an empty one says nothing (except where empty means "none": the subheadline). */
export function ownTextError(value: string | null | undefined, allowEmpty = false): "empty" | null {
  if (value == null || allowEmpty) return null;
  return value.trim() ? null : "empty";
}
